import styles from './PerguntaseRespostas.module.css';
import Accordion from '@/components/Accordion/Accordion';
import jsonData from '@/jsons/PerguntaseRespostas.json';

interface PerguntasData {
    perguntaserespostas: { id: number; title: string; content: string }[];
}

const PerguntaseRespostas = () => {
    const data: PerguntasData = jsonData;
    const perguntaserespostas = data.perguntaserespostas;

    return (
        <section className={styles.perguntasRespostas}>
            <div className={styles.uiContainer}>
                <h3 tabIndex={0} className={styles.title}>Respostas para suas perguntas</h3>
                <Accordion
                    items={perguntaserespostas.map((item) => ({
                        id: item.id,
                        pergunta: item.title,
                        resposta: item.content,
                    }))}
                    showFeedback={false}
                    itemClassName="accordion-White"
                />
            </div>
        </section>
    );
};

export default PerguntaseRespostas;